import { ILocationParams } from '../../../common/reducers/reactRouterLocation'
import { Consent } from '../../../common/utils/consent'
import {
  getLocalStorageItem,
  setLocalStorageItem
} from '../../../common/utils/localStorageHelpers'

import { MakeSearchLink } from '../../../common/utils/location/types'

class RecentSearch {
  public static addItem(item: string): void {
    const recentSearch = getLocalStorageItem(
      RecentSearch.RECENT_SEARCH,
      Consent.preferences,
      []
    )
    RecentSearch.updateRecentSearch(recentSearch, item)
  }

  public static getRecentSearch(
    locationParams: ILocationParams,
    makeSearchLink: MakeSearchLink
  ): any[] {
    const recentSearch = getLocalStorageItem(
      RecentSearch.RECENT_SEARCH,
      Consent.preferences,
      []
    )
    return recentSearch.map((item: string) =>
      RecentSearch.createSuggestion(item, locationParams, makeSearchLink)
    )
  }

  private static readonly RECENT_SEARCH = 'recentSearch'
  private static readonly MAX_COUNT = 5

  private static updateRecentSearch(recentSearch: string[], item: string) {
    if (recentSearch.includes(item)) {
      RecentSearch.bringItemToFront(recentSearch, item)
    } else {
      RecentSearch.ensureItemCount(recentSearch, RecentSearch.MAX_COUNT - 1)
      recentSearch.unshift(item)
    }
    setLocalStorageItem(
      RecentSearch.RECENT_SEARCH,
      recentSearch,
      Consent.preferences
    )
  }

  private static bringItemToFront(recentSearch: string[], item: string): void {
    const itemIndex = recentSearch.indexOf(item)
    recentSearch.splice(itemIndex, 1)
    recentSearch.unshift(item)
  }

  private static ensureItemCount(
    recentSearch: string[],
    maxCount: number
  ): void {
    if (recentSearch.length > maxCount) {
      recentSearch.pop()
    }
  }

  private static createSuggestion(
    item: string,
    locationParams: ILocationParams,
    makeSearchLink: MakeSearchLink
  ): {} {
    const nextQueries = { ...locationParams, term: item }
    const link = makeSearchLink(nextQueries)
    return {
      link,
      text: item
    }
  }
}

export default RecentSearch
